// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1_rbS","author":"Table_author__qvXnQ","authorImage":"Table_authorImage__iLano","unreadRow":"Table_unreadRow__Cx2qI"};